
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function FranjaCotizar() {
    return (
        <div className='cotizar'>
            <div className='in'>
                <p><small>__</small> COTIZA EN LINEA</p>

                <div className="tablet">
                    <img
                        src={"/images/home/icono_2_tablet.svg"}
                        alt='icono web'
                    />
                </div>

                <div className="note">
                    <img
                        src={"/images/home/icono_2_escritorio.svg"}
                        alt='icono web'
                    />
                </div>

                <Button variant="primary" data-bs-toggle="modal" data-bs-target="#modalCotizar">
                    Cotiza
                </Button>
            </div>
        </div>
    )
}